// extracted by mini-css-extract-plugin
module.exports =  {"search":"search--OVBpu","search-input":"search-input--Ij2Ku","searchInput":"search-input--Ij2Ku"};